<template>
  <div ref="rootRef" :class="b(mods)">
    <div :class="b('slides')" @scroll="onScroll($event)">
      <div
        v-for="(item, index) in itemsInternal"
        :key="index"
        :class="b('slide')"
      >
        <slot :item="item" :visible="index === activeIndex" name="item" />
      </div>
    </div>
    <div v-if="itemsInternal.length > 1" :class="b('dots', { size: sizeDots })">
      <div
        v-for="(_, index) in itemsInternal"
        :key="index"
        :class="b('dot', { active: index === activeIndex, size: sizeDots })"
      />
    </div>
  </div>
</template>

<script src="./touch-slider.scripts.js" />

<style lang="scss" src="./touch-slider.styles.scss" />
